module.exports = __webpack_public_path__ + "static/media/bg-video.7e034d80.svg";